var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPressalitLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "170px",
    height: "23px",
    viewBox: "0 0 170 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A15F4475-20DE-416E-8903-EC3BE509EA01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Pressalit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Care---Collection-detail-page",
    transform: "translate(-200.000000, -4839.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer",
    transform: "translate(0.000000, 4699.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer-info"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.000000, 140.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pressalit_logo_4c",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    points: "125.693 1.418 127.867 1.418 127.867 20.459 141.232 20.459 141.232 22.472 125.693 22.472 125.693 1.418"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "143.414 22.471 145.595 22.471 145.595 1.418 143.414 1.418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.567,18.103 C39.422,14.663 38.796,12.751 35.828,12.268 L35.828,12.216 C38.568,11.587 39.952,9.351 39.952,7.11 C39.952,2.689 36.676,1.418 33.108,1.418 L21.641,1.418 L21.641,22.473 L23.826,22.473 L23.826,3.417 L33.254,3.417 C35.263,3.417 37.601,4.015 37.601,7.11 C37.601,10.314 35.444,11.202 33.056,11.202 L26.895,11.202 L26.006,13.215 L32.287,13.215 C35.913,13.215 37.336,14.448 37.387,18.163 C37.413,20.458 37.567,22.025 37.952,22.473 L40.314,22.473 C39.808,21.993 39.628,19.432 39.567,18.103",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    points: "60.146 12.562 60.146 10.56 49.186 10.56 48.294 12.562 60.146 12.562"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-5",
    points: "46.106 20.458 46.106 3.417 60.675 3.417 60.675 1.418 43.923 1.418 43.923 22.473 60.916 22.473 60.916 20.458 46.106 20.458"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-6",
    points: "114.365 1.418 111.834 1.418 102.285 22.472 104.637 22.472 113.074 3.593 117.703 14.072 110.576 14.072 109.686 16.078 118.584 16.078 121.388 22.472 123.916 22.472 114.365 1.418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.101,1.418 L0.755,1.418 L0.755,22.472 L2.938,22.472 L2.938,3.417 L11.82,3.417 C14.318,3.417 16.089,4.335 16.089,7.481 C16.089,9.94 15.028,11.613 11.376,11.613 L6.009,11.613 L5.122,13.627 L11.137,13.627 C15.824,13.627 18.452,11.471 18.452,7.481 C18.452,3.039 15.353,1.418 12.101,1.418",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.768,10.847 C68.63,9.995 66.076,9.351 66.076,6.606 C66.076,4.218 68.63,2.908 72.031,2.908 C74.811,2.908 77.266,3.527 78.225,5.743 L80.578,5.743 C79.601,2.073 75.804,0.882 72.031,0.882 C67.959,0.882 63.712,2.394 63.712,6.998 C63.712,10.38 66.399,11.798 71.409,12.592 C75.239,13.216 79.072,13.596 79.072,16.806 C79.072,20.138 75.795,20.998 72.644,20.998 C69.189,20.998 66.52,20.214 65.596,17.209 L63.32,17.209 C64.27,21.547 67.881,23 72.644,23 C76.745,23 81.435,21.587 81.435,16.427 C81.435,12.389 77.601,11.502 73.768,10.847",
    id: "Fill-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.988,10.847 C88.861,9.995 86.293,9.351 86.293,6.606 C86.293,4.218 88.861,2.908 92.249,2.908 C95.027,2.908 97.494,3.527 98.453,5.743 L100.795,5.743 C99.822,2.073 96.021,0.882 92.249,0.882 C88.176,0.882 83.941,2.394 83.941,6.998 C83.941,10.38 86.611,11.798 91.631,12.592 C95.466,13.216 99.298,13.596 99.298,16.806 C99.298,20.138 96.021,20.998 92.863,20.998 C89.4,20.998 86.738,20.214 85.814,17.209 L83.547,17.209 C84.498,21.547 88.107,23 92.863,23 C96.962,23 101.65,21.587 101.65,16.427 C101.65,12.389 97.82,11.502 93.988,10.847",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-12",
    points: "158.15 22.472 158.15 1.419 148.087 1.419 148.087 3.417 155.974 3.417 155.974 22.472 158.15 22.472"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-13",
    points: "166.406 1.418 161.1 1.418 160.211 3.417 166.406 3.417 166.406 1.418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.842,19.409 L166.387,19.409 C166.753,19.409 167.052,19.372 167.052,18.944 C167.052,18.581 166.7,18.52 166.393,18.52 L165.842,18.52 L165.842,19.409 Z M165.267,18.071 L166.453,18.071 C167.221,18.071 167.636,18.331 167.636,18.99 C167.636,19.562 167.281,19.784 166.842,19.836 L167.681,21.205 L167.058,21.205 L166.267,19.855 L165.842,19.855 L165.842,21.205 L165.267,21.205 L165.267,18.071 Z M166.358,21.843 C167.525,21.843 168.491,20.911 168.491,19.586 C168.491,18.265 167.525,17.334 166.358,17.334 C165.168,17.334 164.221,18.265 164.221,19.586 C164.221,20.911 165.168,21.843 166.358,21.843 Z M166.358,16.707 C167.836,16.707 169.161,17.877 169.161,19.586 C169.161,21.308 167.836,22.472 166.358,22.472 C164.871,22.472 163.547,21.308 163.547,19.586 C163.547,17.877 164.871,16.707 166.358,16.707 Z",
    id: "copyright"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressalitLogoWhite);
export default __webpack_public_path__ + "static/media/pressalit_logo_white.e3e89de0de09b004b07772498633fbed.svg";
export { ForwardRef as ReactComponent };